var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-start flex-row items-center",style:({
    left: ((_vm.element.startPosition * 100) + "%"),
    opacity: ("" + _vm.opacity),
    transform: ("scale(" + (_vm.element.startScale) + ")"),
    marginBottom: "50px",
    width:'100%',
    height:'100%',
    backgroundColor: _vm.element.backgroundColor,
  }),attrs:{"id":_vm.element.Oid + '-element'}},[_c('div',{staticClass:"ql-editor flex-column",style:({ color: _vm.element.titleColor, textAlign: 'center', display: 'flex', justifyContent:'flex-start'})},[(_vm.element.url)?_c('img',{staticClass:"h-12",staticStyle:{"display":"block"},attrs:{"src":_vm.element.url}}):_vm._e(),_c('span',{staticStyle:{"margin-top":"1%","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.element.text)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }